import React from 'react';

// Rounded gray field with optional bold label above (mockup form fields).
export function FieldInput({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  textarea = false,
  className = '',
  ...props
}) {
  const fieldClass =
    'w-full rounded-3xl border-0 bg-[#F0F0F0] px-5 py-3 text-black placeholder-gray-400 ' +
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500';

  return (
    <div className={className}>
      {label && <label className="mb-1 block font-bold text-black">{label}</label>}
      {textarea ? (
        <textarea
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={5}
          className={fieldClass}
          {...props}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={fieldClass}
          {...props}
        />
      )}
    </div>
  );
}
